export const ROUTES = {
  // Public routes
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',

  // Protected routes
  DASHBOARD: '/dashboard',
  PROFILE: '/profile',
  SETTINGS: '/settings',

  // Admin routes
  ADMIN: {
    BASE: '/admin',
    DASHBOARD: '/admin/dashboard',
    USERS: '/admin/users',
    STUDENTS: '/admin/students',
    TEACHERS: '/admin/teachers',
    PARENTS: '/admin/parents',
    CLASSES: '/admin/classes',
    SUBJECTS: '/admin/subjects',
    ATTENDANCE: '/admin/attendance',
    GRADES: '/admin/grades',
    REPORTS: '/admin/reports',
  },

  // Teacher routes
  TEACHER: {
    BASE: '/teacher',
    DASHBOARD: '/teacher/dashboard',
    CLASSES: '/teacher/classes',
    STUDENTS: '/teacher/students',
    ATTENDANCE: '/teacher/attendance',
    GRADES: '/teacher/grades',
    ASSIGNMENTS: '/teacher/assignments',
    REPORTS: '/teacher/reports',
  },

  // Student routes
  STUDENT: {
    BASE: '/student',
    DASHBOARD: '/student/dashboard',
    CLASSES: '/student/classes',
    ATTENDANCE: '/student/attendance',
    GRADES: '/student/grades',
    ASSIGNMENTS: '/student/assignments',
    SCHEDULE: '/student/schedule',
  },

  // Parent routes
  PARENT: {
    BASE: '/parent',
    DASHBOARD: '/parent/dashboard',
    COURSES: '/parent/courses',
    ENROLLMENTS: '/parent/enrollments',
    REWARDS: '/parent/rewards',
    PAYMENTS: '/parent/payments',
    LEADERBOARD: '/parent/leaderboard',
    CERTIFICATES: '/parent/certificates',
    SETTINGS: '/parent/settings',
    CHILDREN: '/parent/children',
    ATTENDANCE: '/parent/attendance',
    GRADES: '/parent/grades',
    PROGRESS: '/parent/progress',
    REPORTS: '/parent/reports',
    COMMUNICATION: '/parent/communication',
  },
} as const
